import { render } from "./quiz.vue?vue&type=template&id=09443fd7"
import script from "./quiz.vue?vue&type=script&lang=js"
export * from "./quiz.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__